/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { Badge } from "antd";
import {
  Collapse,
  Form,
  Flex,
  Row,
  Col,
  Space,
  Card,
  message,
  Select,
} from "antd";
import { Input, Button, Table, Typography } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from "../../../hooks/useAccessPageState";
import ActiveStatusItem, {
  ACTIVE_STATUS_DEFAULT,
  withDefaultStatus,
} from "../../../components/form/ActiveStatusItem";

// import dayjs from 'dayjs';
import OptionService from "../../../service/ERP/Options.service";
import MasterProcessService from "../../../service/ERP/MasterProcess.service";

const opService = OptionService();
const masterProcessService = MasterProcessService();

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const MasterProcessAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v , p: "master-process"};
      opService
        .optionsFG(data)
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", ACTIVE_STATUS_DEFAULT);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: ACTIVE_STATUS_DEFAULT }, nextPagination);
  };

  const handleEdit = (data) => {
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Master Process",
          action: "edit",
          fg_code: data?.fg_code,
        },
      },
    });
  };

  const handleView = (data) => {
    navigate("view", {
      state: {
        config: {
          ...mngConfig,
          title: "Master Process",
          action: "view",
          fg_code: data?.fg_code,
        },
      },
    });
  };

  const handlePrint = (data) => {
    if (!data?.fg_code) return;
    window.open(`/mp-print/${encodeURIComponent(data.fg_code)}`, "_blank");
  };

  const handleDelete = (data) => {
    // startLoading();
    // ctmService.deleted(data?.dncode).then( _ => {
    //     const tmp = accessData.filter( d => d.dncode !== data?.dncode );
    //     setAccessData([...tmp]);
    // })
    // .catch(err => {
    //     console.log(err);
    //     message.error("Request error!");
    // });
  };

  const init = async () => {
    getData({});
  };

  useEffect(() => {
    const restored = restoreState();

    /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดการใช้งาน" */
    const values = withDefaultStatus(restored?.searchValues);
    form.setFieldsValue(values);

    handleSearch(values, restored?.tablePagination);
    return async () => {
      //console.clear();
    };
  }, []);

  const getData = () => {
    handleSearch();
  };

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="รหัสสินค้า"
                      name="fg_code"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Product Code" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="ชื่อสินค้า"
                      name="fg_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Product Name" />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="ประเภทสินค้า" name="product_type">
                      <Select
                        size="large"
                        onChange={handleSearch}
                        options={[
                          {
                            value: "pg",
                            label: "Packing Goods",
                          },
                          {
                            value: "fg",
                            label: "Finished Goods",
                          },
                          {
                            value: "wi",
                            label: "Work Instruction",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col> */}
                  <ActiveStatusItem onChange={handleSearch} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const allColumns = accessColumn({ handleEdit, handleDelete, handleView, handlePrint });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "master_process_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Master Process
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
        </Flex>
      </Col>
      {/* <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create PG
          </Button>
        </Flex>
      </Col> */}
    </Flex>
  );
  return (
    <div className="bom-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="mat_code"
                columns={column}
                dataSource={accessData}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default MasterProcessAccess;
